import PropTypes from 'prop-types'
import { useFlag } from '@calendly/feature-check-react'
import styled from 'astroturf/react'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
const colorBackgroundStandard = 'var(--colorBackgroundStandard, var(--coreColorNeutral0))'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { Avatar as CuiAvatar } from '@calendly/ui/components/avatar'
import { Avatar, CompanyLogo, EventTypeName, Name, ProfileContainer } from '@calendly/booking-kit'
import _Container from "index-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/profile/index.js?styleId=Container";
import _RedesignDesktopBrandBlock from "index-RedesignDesktopBrandBlock.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/profile/index.js?styleId=RedesignDesktopBrandBlock";
import _RedesignTabletLogoOuter from "index-RedesignTabletLogoOuter.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/profile/index.js?styleId=RedesignTabletLogoOuter";
import _RedesignTabletLogoInner from "index-RedesignTabletLogoInner.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/profile/index.js?styleId=RedesignTabletLogoInner";
import _RedesignLogoCard from "index-RedesignLogoCard.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/profile/index.js?styleId=RedesignLogoCard";
import _RedesignLogoImage from "index-RedesignLogoImage.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/profile/index.js?styleId=RedesignLogoImage";
import _RedesignAvatarRingOverlap from "index-RedesignAvatarRingOverlap.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/profile/index.js?styleId=RedesignAvatarRingOverlap";
import _RedesignTabletAvatarRow from "index-RedesignTabletAvatarRow.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/profile/index.js?styleId=RedesignTabletAvatarRow";

const spacing0_5x = 'var(--spacing-0-5x, 0.5rem)'
const spacing0_75x = 'var(--spacing-0-75x, 0.75rem)'
const spacing1_25x = 'var(--spacing-1-25x, 1.25rem)'
const spacing1_5x = 'var(--spacing-1-5x, 1.5rem)'
const spacing1_5xNegative = 'var(--spacing-1-5x-negative, -1.5rem)'
const spacing1x = 'var(--spacing-1x, 1rem)'
const spacing3_5x = 'var(--spacing-3-5x, 3.5rem)'

const Container = /*#__PURE__*/styled(ProfileContainer, null, {
  displayName: "Container",
  styles: _Container
})

const RedesignDesktopBrandBlock = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignDesktopBrandBlock",
  styles: _RedesignDesktopBrandBlock
})

const RedesignTabletLogoOuter = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignTabletLogoOuter",
  styles: _RedesignTabletLogoOuter
})

const RedesignTabletLogoInner = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignTabletLogoInner",
  styles: _RedesignTabletLogoInner
})

const RedesignLogoCard = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignLogoCard",
  styles: _RedesignLogoCard
})

const RedesignLogoImage = /*#__PURE__*/styled('img', null, {
  displayName: "RedesignLogoImage",
  styles: _RedesignLogoImage
})

const RedesignAvatarRingOverlap = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignAvatarRingOverlap",
  styles: _RedesignAvatarRingOverlap
})

const RedesignTabletAvatarRow = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignTabletAvatarRow",
  styles: _RedesignTabletAvatarRow
})

const Profile = ({
  avatar = null,
  eventTypeName = null,
  logoUrl = null,
  name = null,
  reduced = false,
  sidebar = false
}) => {
  const isPhone = useDeviceType('isPhone')
  const isDesktopUp = useDeviceType('isDesktopUp')
  const bookingAppRedesign = useFlag('booking_app_redesign', false)
  const hideWhenReduced = reduced && isPhone
  const nameTag = eventTypeName ? 'div' : 'h1'
  const logoVisible = sidebar && Boolean(logoUrl)
  const showRedesignBrand = bookingAppRedesign && logoVisible
  const companyLogoAlt = name ? `${name} logo` : 'Company logo'
  const avatarLabel = name || ''
  const redesignAvatar = avatar && !hideWhenReduced && (
    <CuiAvatar size="x-large" src={avatar} aria-label={avatarLabel} />
  )

  const logoCard = (
    <RedesignLogoCard isDesktopUp={isDesktopUp} withAvatarOverlap={Boolean(redesignAvatar)}>
      <RedesignLogoImage isDesktopUp={isDesktopUp} src={logoUrl} alt={companyLogoAlt} />
    </RedesignLogoCard>
  )

  return (
    <Container reducedView={reduced} bookingAppRedesign={bookingAppRedesign}>
      {showRedesignBrand && isDesktopUp && (
        <RedesignDesktopBrandBlock data-profile="redesign-desktop-brand">
          {logoCard}
          {redesignAvatar && (
            <RedesignAvatarRingOverlap data-profile="redesign-desktop-avatar">
              {redesignAvatar}
            </RedesignAvatarRingOverlap>
          )}
        </RedesignDesktopBrandBlock>
      )}
      {showRedesignBrand && !isDesktopUp && (
        <>
          <RedesignTabletLogoOuter data-profile="redesign-tablet-logo">
            <RedesignTabletLogoInner>
              {logoCard}
            </RedesignTabletLogoInner>
          </RedesignTabletLogoOuter>
          {redesignAvatar && (
            <RedesignTabletAvatarRow data-profile="redesign-tablet-avatar">
              {redesignAvatar}
            </RedesignTabletAvatarRow>
          )}
        </>
      )}
      {!showRedesignBrand && (
        <>
          {logoVisible && <CompanyLogo url={logoUrl} />}
          {avatar && !hideWhenReduced && (
            <Avatar src={avatar} alt={name} withLogo={logoVisible} sidebarView={sidebar} />
          )}
        </>
      )}
      {name && !hideWhenReduced && (
        <Name as={nameTag} sidebarView={sidebar} bookingAppRedesign={bookingAppRedesign}>{name}</Name>
      )}
      {eventTypeName && (
        <EventTypeName sidebarView={sidebar} bookingAppRedesign={bookingAppRedesign}>{eventTypeName}</EventTypeName>
      )}
    </Container>
  )
}

Profile.propTypes = {
  avatar: PropTypes.string,
  name: PropTypes.string,
  logoUrl: PropTypes.string,
  eventTypeName: PropTypes.string,
  reduced: PropTypes.bool,
  sidebar: PropTypes.bool
}

export default Profile
